import React from 'react';
import { ToastContainer } from 'react-toastify';
import ReactGA from "react-ga4";
import { Outlet, useLocation } from "react-router-dom";
import PublicHeader from './modules/PublicHeader';
import { notify } from "../services/NotificationService";
import '../assets/css/global.css';

// Coquille des pages destinées au client final : suivi de location,
// paiement, caution, documents du matériel.
export default function Root() {
    const location = useLocation();
    const isPublicRentalPage = location.pathname.startsWith('/malocation');

    if (window.location.href.indexOf("localhost") === -1) {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: window.location.pathname });
    }

    notify();

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={8000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light" />

            <PublicHeader hideLoginLink />

            <main id="detailPublic" className={`lk-public-main${isPublicRentalPage ? " detail-public-rental" : ""}`}>
                <Outlet />
            </main>
        </>
    );
}
